<template>
    <div v-if="show" class="mask">
      <div class="scan-login flex flex-col">
        <div class="flex flex-space-between full-width">
            <div class="font-bold">登录</div>
            <div class="pointer" @click="close"><img class="logo-22" src="@/assets/images/guanbi.png"/></div>
        </div>
        
        <div class="flex flex-center-sp" style="margin-top: 40px;">
          <div>微信扫码关注公众号登录</div>
        </div>
        <div class="flex flex-center-sp margin-top-xl">
            <img  v-if="imageUrl != ''" style="width: 200px;height: 200px;" :src="imageUrl"/>
        </div>


      </div>
    </div>
  </template>
   
  <script>
  
  import {getTempQrCode,checkScanState,updateRealname} from '@/api/api.js';
  import {getShareToken,objToStr} from '@/utils/sysUtils'

  export default {
      name: 'ScanLogin',
      props: {
          show: {},
      },
      watch: {
        show(val){
           if (val == true) {
              this.$showLoading();
              getTempQrCode(this.token).then((res) => {
                console.log("res==========",res);
                  this.$closeLoading();
                  this.imageUrl = objToStr(res.data.message);
                  setTimeout(() => {
                      this.check();               
                  }, 1000);
              }) 
           }
        },
      },
      
      created() {


      },
      data() {
          return {
            timer: null,
            imageUrl: "",
            token: getShareToken(12)
          }
      },
  
      methods: {
        check() {
          if (this.show == false) return false;
          checkScanState(this.token).then((res) => {
              console.log(res);
              console.log("check....");
              if (res.data.success == true) {
                  sessionStorage.setItem('token', res.data.result.token)
                  sessionStorage.setItem('userId', res.data.result.userInfo.id)
                  sessionStorage.setItem('userName', res.data.result.userInfo.username)
                  sessionStorage.setItem('realname', res.data.result.userInfo.realname)
                  sessionStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
                  sessionStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

                  localStorage.setItem("token", res.data.result.token);
                  localStorage.setItem("userId", res.data.result.userInfo.id);
                  localStorage.setItem('sex', res.data.result.userInfo.sex)
                  localStorage.setItem("userName", res.data.result.userInfo.username);
                  localStorage.setItem("realname", res.data.result.userInfo.realname);
                  localStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
                  localStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

                  if (objToStr(res.data.result.userInfo.realname) == "") {
                    this.$showInputBox({
                        caption: "输入您的姓名",
                        inputValue: '',
                        callback: (data) => {
                          updateRealname(res.data.result.userInfo.id, data).then((res) => {
                            sessionStorage.setItem('realname', data)
                            this.$emit("close");
                            this.$closeInputBox();    
                          })
                        }
                    })
                  }
                  this.$emit("confirm");
              } else {
                  setTimeout(() => {
                    this.check();               
                  }, 1000);
              }
          })           
        },
        close() {
            this.$emit("close");
        }
      }
  }
  </script>
  
  <style scoped>
      .scan-login {
          border-radius: 5px;
          width: 450px;
          height: 400px;
          background-color: #fff;
          padding: 20px;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
      }
  </style>
  


// WEBPACK FOOTER //
// src/modules/scanLogin/ScanLogin.vue